module.exports = __webpack_public_path__ + "bc289739bc2aafbc69a5732f5d67ec4f.svg";